import { Component, Input, OnInit } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { ActiveMeters } from "../edp-consumptions.models";
import moment from "moment";

@Component({
    selector: "edp-widget-consumptions-jumbotron",
    templateUrl: "./edp-widget-consumptions-jumbotron.component.html"
})
export class EdpWidgetConsumptionsJumbotronComponent implements OnInit {
    @Input() contract: Contract;
    @Input() activeMeters: ActiveMeters;
    @Input() isMultiMeter: boolean;
    public isSameMonthRangeIRD: boolean;
    public noConsumptionData: boolean;

    public ngOnInit() {
        this.isSameMonthRangeIRD = moment(this.contract.Ird_start).isSame(moment(this.contract.Ird_end), "month");
        if (!this.contract.Ird_start || !this.contract.Ird_end) {
            this.noConsumptionData = true;
        }
    }

}
